import { ContactTypeResolver } from './../contact/services/contact.resolver.service';
import { ClientEditResolver, ClientContactListResolver,
    ModuleListResolver,
     ClientListByBusinessResolver,
    CountryCodeResolver
} from './services/client.resolver.service';
import { ClientComponent } from './client.component';
import { ClientListComponent } from './components/client-list/client-list.component';
import { CreateClientComponent } from './components/new-client/new-client.component';
import { Route } from '@angular/router';

export const clientRoutes: Route[] = [
    {
        path: 'client',
        component: ClientComponent,
        children: [
            {
                path: 'list',
                component: ClientListComponent,
                resolve: {
                    list: ClientListByBusinessResolver
                }
            },
            {
                path: 'new',
                component: CreateClientComponent,
                resolve: {
                    contactType: ContactTypeResolver,
                    countryCode: CountryCodeResolver
                }
            },
            {
                path: 'edit/:cid',
                component: CreateClientComponent,
                resolve: {
                    edit: ClientEditResolver,
                    contactlist: ClientContactListResolver,
                    module: ModuleListResolver,
                    contactType: ContactTypeResolver,
                    countryCode: CountryCodeResolver
                }
            },
        ]
    }

];